module.exports = __webpack_public_path__ + "media/images/logos/vr_logo_with_text-bfd52260625b696cb706ed074ecb2462.svg";